import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-start -space-y-2 overflow-hidden w-8 flex-shrink-0" }
const _hoisted_2 = { class: "flex flex-col items-start flex-grow ml-3 space-y-1" }
const _hoisted_3 = { class: "flex items-baseline justify-start space-x-1" }

import type { PropType } from 'vue';
import { ref, computed } from 'vue';
import { format } from 'date-fns';
import { useIntersectionObserver } from '@vueuse/core';
import { Message } from '../../../models/message';
import UserAvatar from '../../../components/UserAvatar.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  message: {
    type: Object as PropType<Message>,
    required: true,
  },
},
  setup(__props) {

const props = __props


const message = {
  uid: '0273764023492394',
  body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed gravida semper turpis a convallis. Aliquam erat volutpat. Curabitur fringilla elit nisi, ultrices facilisis ante accumsan sed. Aenean ullamcorper, orci sed dictum gravida, ligula mauris rhoncus libero, non placerat est nulla ac urna. Quisque sit amet nulla sit amet nunc feugiat faucibus eu vel elit. Proin a sem ac urna porta elementum in quis ante. Nulla facilisi. Ut non magna eget est aliquam convallis vitae sed mauris. In efficitur est sed leo placerat varius. Sed rhoncus neque ut tortor convallis aliquet. Proin posuere lectus ac ligula ullamcorper, a gravida orci lacinia. Integer fringilla lacinia sem, dapibus lobortis dui vestibulum at. Vestibulum interdum neque vel posuere venenatis. Curabitur vehicula neque et maximus porttitor.',
  from: [{
    type: 'admin',
    value: {},
  }],
  fromDate: {
    uid: '73409273748239',
    displayName: 'Leonard Cooper',
    photoURL: 'https://images.unsplash.com/photo-1593085512500-5d55148d6f0d?ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8Y2FydG9vbnxlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&w=1000&q=80',
  },
  sentAt: 1630858908,
  readBy: [],
};

const isFromCurrentUser = true;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref: (_value, _refs) => {
      _refs['el'] = _value
    },
    class: _normalizeClass(["w-full flex items-start", [
      isFromCurrentUser ? 'justify-end' : 'justify-start',
    ]])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex items-start justify-start w-full lg:w-[75%] p-3.5 rounded-xl shadow-modal", [
        isFromCurrentUser ? 'bg-wrh-blue-light' : 'bg-white',
      ]])
    }, [
      _createElementVNode("div", _hoisted_1, [
        (message.fromData)
          ? (_openBlock(), _createBlock(UserAvatar, {
              key: 0,
              user: message.fromData,
              class: "h-8 w-8"
            }, null, 8, ["user"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: _normalizeClass(["t-14m line-clamp-1", [
              isFromCurrentUser ? 'text-white' : 'text-black',
            ]])
          }, _toDisplayString(message.fromData?.displayName), 3),
          (message.sentAt)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["t-10r text-black", [
              isFromCurrentUser ? 'text-white' : 'text-black',
            ]])
              }, _toDisplayString(_unref(format)(new Date(), 'h:mm aaaa')), 3))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["t-14r", [
            isFromCurrentUser ? 'text-white' : 'text-wrh-gray-dark',
          ]])
        }, _toDisplayString(message.body), 3)
      ])
    ], 2)
  ], 2))
}
}

})